import React, { Component } from 'react';
import {Paper, Grid, Typography, Button, Tooltip, IconButton} from '@material-ui/core';
import * as Gserv from '../services/GatewayService';
// import Settings from '@material-ui/icons/Settings';
import DatasheetView from './DatasheetView';
import moment from 'moment';
import FilterBox from './FilterBox';
import XLSX from 'xlsx';
import ExcelLogo from '../assets/ExcelLogo';
import Toggle from './Toggle';

export default class NominationHistory extends Component {

    constructor(props) {
        super(props);
        this.initial_state = {
            error: false,
            error_message: '',
            querying: true,
            nominations_array: [],
            show_all: false
            // current_record: {},
        }

        this.state = {
            error: false,
            error_message: '',
            querying: true,
            nominations_array: [],
            filtered_nominations_array: [],
            filter_applied: false,
            filter_obj: {},
            show_all: false
        };

        this.datasheetFieldSpecs = [
            { field: 'assessee', headerName: 'Assessee', width: 180},
            { field: 'job_title', headerName: 'Job Title', width: 160},
            { field: 'cycle_code', headerName: 'Cycle Code', width: 160},
            { field: 'assessment_template_id', headerName: 'Type', width: 80, align:'center',headerAlign:'center', sortable:false},
            { field: 'assessment_type_id', headerName: 'By', align: 'center', headerAlign:'center', width: 80, sortable:false},
            { field: 'created', headerName: 'Created', width: 120},
            { field: 'nominated_assessor', headerName: 'Nominated Assessor', width: 190},
            { field: 'assessed', headerName: 'Assessed?', width: 130, headerAlign:'center', align: 'center'},
        ]

    }

    componentDidMount = (show_all = false) => {

        Gserv.sendCommand('query_my_nomination_history',this.props.gwt,{
            show_all: show_all
        })
        .then(reply=>{
            // console.log('query_nom_hist reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (query_my_nomination_history) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                console.log('error on return from Gserv (query_my_nomination_history) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                //clean formats for display
                if (reply.Records){
                    let record_array = reply.Records;
                    let created = null;
                    for (var i=0;i<record_array.length;i++){
                        created = new moment(record_array[i].created).format("YYYY-MM-DD");
                        record_array[i].created = created;
                        if (record_array[i].assessment_id) {
                            record_array[i].assessed = "YES"
                        }
                    }
                }

                if (this.state.filter_applied){
                    this.setState({querying:false, nominations_array:reply.Records?reply.Records : []});
                    if (!reply.Records) {this.setState({filtered_nominations_array:[]})}
                    this.applyFilter(this.state.filter_obj);
                } else {
                    this.setState({querying:false, nominations_array:reply.Records?reply.Records : [], filtered_nominations_array:reply.Records?reply.Records : []});
                }

            }
        });

    };
    
    resetMe = () => {
        this.setState({error:false,error_message:''});
        this.componentDidMount();
    }

    deleteNom = (record) => {
        // console.log('record :>> ', record);

        if (record.row.assessed==="YES"){

            this.setState({error:true,error_message:'Unable to delete nominations where assessments are already complete.'})

        } else {

            this.setState({querying:true});
            Gserv.sendCommand('delete_nomination',this.props.gwt,{
                nomination_id: record.id
            })
            .then(reply => {
                // console.log('delete reply :>> ', reply);
                if (reply.error){
                    console.log('error on return from Gserv (delete_nomination) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else if (reply.Result!=="Success"){
                    console.log('error on return from Gserv (delete_nomination) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else {
                    this.setState({error:false,error_message:'',nominations_array:[]});
                    this.componentDidMount(this.state.show_all);
                }
            });

        }

    }

    handleFilterChange = (filterObj) => {
        // console.log('filterObj :>> ', filterObj);
        if (filterObj.type==='clear'){
            this.setState({filtered_nominations_array : this.state.nominations_array, filter_obj: {}, filter_applied:false})
        } else {
            this.setState({filter_obj:filterObj});
            this.applyFilter(filterObj);
        }
    }

    applyFilter = (filterObj) => {
        if (this.state.nominations_array.length > 0){
            let temp_array = [];
            switch (filterObj.type) {
                case 'name':
                    for (const record of this.state.nominations_array){
                        if (record.assessee.includes(filterObj.search_string)){
                            temp_array.push(record);
                        }
                    }
                    break;

                case 'number':
                    for (const record of this.state.nominations_array){
                        if (record.assessee_id.includes(filterObj.search_string)){
                            temp_array.push(record);
                        }
                    }
                    break;
            
                default:
                    break;
            }
            this.setState({filtered_nominations_array: temp_array, filter_applied:true});
        }
    }

    handleToggleChange = (e) => {
        // console.log('e :>> ', e);
        switch (e.field) {
            case 'show_all':
                this.setState({show_all:e.value});
                this.componentDidMount(e.value);
                break;

            default:
                break;
        }
    }

    exportMe = () => {
        // console.log('called exportMe...');
        if (this.state.filtered_nominations_array.length>0){
            const dateStr = new moment().format("YYYY-MM-DD");
            var ws = XLSX.utils.json_to_sheet(this.state.filtered_nominations_array);
            var wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Nomination History ' + dateStr);
            //Write to browser
            XLSX.writeFile(wb,'TMS Export - Nomination History as at ' + dateStr + '.xlsx');
        }
    }

    render() {
        return (
            <Grid
                container
                direction='column'
                // justifyContent='flex-start'
                // alignContent='flex-start'
                // style={{backgroundColor:'yellow'}}
            >
                <Grid item>
                <Paper
                    elevation={3}
                    style={{
                        // backgroundColor:'yellow',
                        width:1180
                    }}
                >

                    <Grid
                        container
                        justifyContent='center'
                        alignItems='center'
                        // style={{backgroundColor:'green'}}
                    >
                        <Grid item xs={4}>
                            <div style={{display:'flex', justifyContent: 'space-evenly', alignItems:"center"}}>

                                {this.props.super_admin&&
                                <Toggle
                                    fieldMap={{field: "show_all", headerName: "Show All?", f_inputType:'toggle', f_true_tag:'Yes', f_false_tag:'No', f_show:true}} 
                                    setField={this.handleToggleChange}
                                />}

                                <Tooltip title="Export to Excel">
                                <span>
                                <IconButton 
                                    aria-label='Export to Excel'
                                    onClick={this.exportMe}
                                    disabled={this.state.filtered_nominations_array.length===0}
                                >
                                    <ExcelLogo />
                                </IconButton>
                                </span>
                                </Tooltip>
                            </div>
                        </Grid>

                        <Grid item xs={4}>
                            <Typography style={{padding:'15px'}}>
                                Nomination History
                            </Typography>
                        </Grid>
                        
                        <Grid item xs={4}>
                            <Grid 
                                container
                                alignItems='center'
                                justifyContent='space-evenly'
                                // style={{backgroundColor:'yellow'}}
                            >
                                <FilterBox
                                    setParentFilter={this.handleFilterChange}
                                    data_populated={this.state.nominations_array.length>0? true : false}
                                    filter_applied={this.state.filter_applied}
                                    filter_obj={this.state.filter_obj}
                                    // show_hod_filter={this.props.super_admin}
                                    // show_branch_filter={true}
                                    // show_cycle_filter={true}
                                />
                            </Grid>
                        </Grid>
                        
                    </Grid>                   

                    <DatasheetView 
                        dataset={this.state.filtered_nominations_array}
                        fieldspecs={this.datasheetFieldSpecs}
                        delete={true}
                        edit={false}
                        handleDelete={this.deleteNom}
                        handleEdit={null}
                        loading={this.state.querying}
                        deleteHeaderName={'Delete'}
                        height={500}
                    />

                </Paper>
                </Grid>

                <Grid item>
                    <Typography color='secondary' style={{Width:1155,maxWidth:1155, textAlign:'center'}}>{this.state.error_message}</Typography>
                    {this.state.error&&<Button color='primary' variant='outlined' onClick={this.resetMe}>Reset</Button>}
                </Grid>

            </Grid>
        );
    }
    
}